const Offering = {
  offerings: "OFFERINGS",
};
export default Offering;
